import React from 'react';
import {
    Card,
    Flex,
    Tag,
    Tooltip,
    Typography,
} from 'antd';
import {
    ApartmentOutlined,
    CodeOutlined,
    DatabaseOutlined,
    FileSearchOutlined,
} from '@ant-design/icons';

import {InvocationLogData} from "../../../../../../models/logger/logger.data";

const { Text } = Typography;

interface InvocationLogDataPanelProps {
    data: InvocationLogData;
}

const formatStringList = (values?: string[]): string => {
    if (!values?.length) {
        return '—';
    }

    return values.filter(Boolean).join(', ') || '—';
};

const formatParamKey = (key: string): string => {
    if (!key) {
        return key;
    }

    if (key.length <= 3) {
        return key;
    }

    return key.charAt(0).toUpperCase() + key.slice(1);
};

export function InvocationLogDataPanel({ data }: InvocationLogDataPanelProps) {
    const actionParams = Object.entries(data.actionParams || {});

    const mainItems = [
        {
            label: 'Invocation',
            value: formatStringList(data.invocation),
            icon: <FileSearchOutlined />,
        },
        {
            label: 'Action',
            value: formatStringList(data.action),
            icon: <CodeOutlined />,
        },
        {
            label: 'IP',
            value: formatStringList(data.ip),
            icon: <DatabaseOutlined />,
        },
        {
            label: 'Channel',
            value: formatStringList(data.channel),
            icon: <ApartmentOutlined />,
        },
    ];

    return (
        <Card className="invocation-data-card" bordered={false}>
            <div className="invocation-data-grid">
                {mainItems.map((item) => (
                    <div className="invocation-data-item" key={item.label}>
                        <div className="invocation-data-item__label">
                            {item.icon}
                            <span>{item.label}</span>
                        </div>

                        <Tooltip title={item.value}>
                            <Text className="invocation-data-item__value" ellipsis>
                                {item.value}
                            </Text>
                        </Tooltip>
                    </div>
                ))}
            </div>

            <div className="invocation-action-params">
                <div className="invocation-action-params__label">
                    <CodeOutlined />
                    <span>Action params</span>
                </div>

                {actionParams.length ? (
                    <Flex wrap="wrap" gap={8}>
                        {actionParams.map(([key, values]) => (
                            <Tag className="invocation-param-tag" key={key}>
                                <Text strong>{formatParamKey(key)}:</Text>{' '}
                                <Text>{formatStringList(values)}</Text>
                            </Tag>
                        ))}
                    </Flex>
                ) : (
                    <Text type="secondary">—</Text>
                )}
            </div>
        </Card>
    );
}
